// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// REPLACE THESE VALUES WITH YOUR FIREBASE PROJECT KEYS
const firebaseConfig = {
    apiKey: "AIzaSyDdRKOukZgHc53ozmVpDOaoyhaWQuIIN1Q",
    authDomain: "opus-42af6.firebaseapp.com",
    projectId: "opus-42af6",
    storageBucket: "opus-42af6.firebasestorage.app",
    messagingSenderId: "433127925374",
    appId: "1:433127925374:web:53733740a9ff240f4e1a2f",
    measurementId: "G-58T0X9LZ74"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
